/* ==========================================================================
   PREMIUM PRODUCT PAGE (v2)  —  premium-product-page.js
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function initSection(section) {
    if (section.dataset.pppInit === '1') return;
    section.dataset.pppInit = '1';

    var $ = function (sel) { return section.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(section.querySelectorAll(sel)); };

    /* ---------------- GALLERY ---------------- */
    var slides = $$('.ppp__slide');
    var thumbs = $$('.ppp__thumb');
    var dots = $$('.ppp__dot');
    var counter = $('[data-ppp-current]');
    var currentIndex = 0;

    function goTo(i) {
      if (!slides.length) return;
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      currentIndex = i;
      slides.forEach(function (sl, idx) { sl.classList.toggle('is-active', idx === i); });
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      if (counter) counter.textContent = i + 1;
    }
    function goToMediaId(id) {
      var idx = slides.findIndex(function (sl) { return sl.dataset.mediaId === String(id); });
      if (idx > -1) goTo(idx);
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.dataset.index, 10)); }); });
    var prevBtn = $('[data-ppp-prev]'); var nextBtn = $('[data-ppp-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

    // thumbnail scroll arrows
    var thumbsWrap = $('[data-ppp-thumbs]');
    var upArrow = $('.ppp__thumb-arrow--up'); var downArrow = $('.ppp__thumb-arrow--down');
    function scrollThumbs(dir) {
      if (!thumbsWrap) return;
      var vertical = thumbsWrap.scrollHeight > thumbsWrap.clientHeight;
      if (vertical) thumbsWrap.scrollBy({ top: dir * 160, behavior: 'smooth' });
      else thumbsWrap.scrollBy({ left: dir * 160, behavior: 'smooth' });
    }
    if (upArrow) upArrow.addEventListener('click', function () { scrollThumbs(-1); });
    if (downArrow) downArrow.addEventListener('click', function () { scrollThumbs(1); });

    // swipe on mobile
    var stage = $('.ppp__stage');
    if (stage) {
      var startX = 0;
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) goTo(currentIndex + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    // wishlist
    var wish = $('[data-ppp-wish]');
    if (wish) wish.addEventListener('click', function () {
      wish.classList.toggle('is-active');
      wish.textContent = wish.classList.contains('is-active') ? '♥' : '♡';
    });

    /* ---------------- VARIANTS ---------------- */
    var variantsEl = $('[data-ppp-variants]');
    var pricesEl = $('[data-ppp-prices]');
    var variants = variantsEl ? safeJSON(variantsEl.textContent) : null;
    var prices = pricesEl ? safeJSON(pricesEl.textContent) : {};
    var idInput = $('[data-ppp-variant-id]');
    var priceWrap = $('[data-ppp-price]');
    var stickyPrice = $('[data-ppp-sticky-price]');
    var stockWrap = $('[data-ppp-stock]');
    var stockText = $('[data-ppp-stock-text]');
    var addBtn = $('[data-ppp-add]');
    var addText = $('[data-ppp-add-text]');
    var buyBtn = $('[data-ppp-buy]');
    var showSave = section.dataset.saveBadge === '1';

    function selectedOptions() {
      var opts = [];
      $$('[data-ppp-option]:checked').forEach(function (inp) {
        opts[parseInt(inp.dataset.optionPosition, 10) - 1] = inp.value;
      });
      return opts;
    }
    function matchVariant(opts) {
      if (!variants) return null;
      return variants.find(function (v) {
        return opts.every(function (val, i) { return v.options[i] === val; });
      });
    }
    function updateForVariant(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;

      // selected option labels
      $$('.ppp__selected-option').forEach(function (span) {
        var pos = parseInt(span.dataset.selectedOption, 10);
        span.textContent = v.options[pos - 1] || '';
      });

      // price
      var pinfo = prices[v.id];
      if (priceWrap && pinfo) {
        var html = pinfo.price;
        if (pinfo.compare_raw && pinfo.compare_raw > pinfo.price_raw) {
          html += ' <s>' + pinfo.compare + '</s>';
          var pct = Math.round((pinfo.compare_raw - pinfo.price_raw) * 100 / pinfo.compare_raw);
          if (showSave) html += ' <span class="ppp__save" data-ppp-save>-' + pct + '%</span>';
        }
        priceWrap.innerHTML = html;
      }
      if (stickyPrice && pinfo) stickyPrice.textContent = pinfo.price;

      // availability
      var available = v.available;
      if (addBtn) addBtn.disabled = !available;
      if (buyBtn) buyBtn.disabled = !available;
      if (addText) addText.textContent = available ? (addText.dataset.inText || addText.textContent) : (addText.dataset.outText || 'Sold out');
      if (stockWrap) {
        stockWrap.classList.toggle('is-out', !available);
        if (stockText) stockText.textContent = available ? (stockText.dataset.inText || stockText.textContent) : (stockText.dataset.outText || 'Sold out');
      }

      // swap image
      if (v.featured_media && v.featured_media.id) goToMediaId(v.featured_media.id);
    }

    $$('[data-ppp-option]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var v = matchVariant(selectedOptions());
        updateForVariant(v);
      });
    });

    /* ---------------- QUANTITY ---------------- */
    var qtyInput = $('.ppp__qty input');
    var minus = $('[data-qty-minus]'); var plus = $('[data-qty-plus]');
    var offerQty = 0;
    function qty() {
      if (qtyInput) return Math.max(1, parseInt(qtyInput.value, 10) || 1);
      if (offerQty) return offerQty;
      return 1;
    }
    if (minus) minus.addEventListener('click', function () { if (qtyInput) qtyInput.value = Math.max(1, qty() - 1); });
    if (plus) plus.addEventListener('click', function () { if (qtyInput) qtyInput.value = qty() + 1; });

    /* ---------------- BUNDLE OFFERS ---------------- */
    var offerInputs = $$('[data-ppp-offer]');
    function syncOffers() {
      $$('.ppp__offer').forEach(function (l) {
        var i = l.querySelector('[data-ppp-offer]');
        l.classList.toggle('is-selected', !!(i && i.checked));
      });
    }
    if (offerInputs.length) {
      offerInputs.forEach(function (inp) {
        inp.addEventListener('change', function () {
          offerQty = Math.max(1, parseInt(inp.value, 10) || 1);
          if (qtyInput) qtyInput.value = offerQty;
          syncOffers();
        });
      });
      var checkedOffer = offerInputs.filter(function (i) { return i.checked; })[0];
      if (checkedOffer) {
        offerQty = Math.max(1, parseInt(checkedOffer.value, 10) || 1);
        if (qtyInput) qtyInput.value = offerQty;
      }
      syncOffers();
    }

    /* ---------------- TABS ---------------- */
    $$('.ppp__tabs').forEach(function (tabWrap) {
      var btns = Array.prototype.slice.call(tabWrap.querySelectorAll('.ppp__tab-button'));
      var panels = Array.prototype.slice.call(tabWrap.querySelectorAll('.ppp__tab-panel'));
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          b.classList.add('is-active');
          var target = tabWrap.querySelector('[data-panel="' + b.dataset.tab + '"]');
          if (target) target.classList.add('is-active');
        });
      });
    });

    /* ---------------- COLLAPSIBLES ---------------- */
    $$('[data-ppp-collapse-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('[data-ppp-collapse]').classList.toggle('is-open');
      });
    });

    /* ---------------- COUNTDOWN ---------------- */
    $$('[data-ppp-countdown]').forEach(function (cd) {
      var mins = parseInt(cd.dataset.minutes, 10) || 30;
      var timerEl = cd.querySelector('[data-ppp-timer]');
      var end = Date.now() + mins * 60000;
      function tick() {
        var left = Math.max(0, end - Date.now());
        var m = Math.floor(left / 60000);
        var sec = Math.floor((left % 60000) / 1000);
        if (timerEl) timerEl.textContent = String(m).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
        if (left > 0) requestAnimationFrame(function () { setTimeout(tick, 500); });
      }
      tick();
    });

    /* ---------------- ADD TO CART / BUY NOW ---------------- */
    var form = $('[data-ppp-form]');
    var buyBehavior = section.dataset.buyBehavior || 'checkout';

    function currentId() { return idInput ? idInput.value : (variants && variants[0] && variants[0].id); }

    function toast(msg) {
      var t = document.createElement('div');
      t.className = 'ppp__toast';
      t.textContent = msg;
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('is-visible'); });
      setTimeout(function () { t.classList.remove('is-visible'); setTimeout(function () { t.remove(); }, 250); }, 2200);
    }

    function refreshCartCount() {
      fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count], .cart-count, #cart-icon-bubble .cart-count-bubble span:first-child')
            .forEach(function (el) { el.textContent = c.item_count; });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: c } }));
        }).catch(function () {});
    }

    function addToCart(redirect) {
      var id = currentId();
      if (!id) return;
      var btn = redirect ? buyBtn : addBtn;
      if (btn) btn.classList.add('is-loading');
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty() })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (btn) btn.classList.remove('is-loading');
          if (!res.ok) { toast(res.d && res.d.description ? res.d.description : 'Could not add to cart'); return; }
          if (redirect) {
            window.location.href = buyBehavior === 'cart' ? (ROOT + 'cart') : (ROOT + 'checkout');
          } else {
            refreshCartCount();
            toast('✓ Added to cart');
            // agar theme ka cart drawer hai to open karne ki koshish
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
          }
        })
        .catch(function () { if (btn) btn.classList.remove('is-loading'); toast('Network error'); });
    }

    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(false); });
    if (buyBtn) buyBtn.addEventListener('click', function () { addToCart(true); });

    /* ---------------- STICKY MOBILE BAR ---------------- */
    var sticky = $('[data-ppp-sticky]');
    var stickyCart = $('[data-sticky-cart]');
    var stickyBuy = $('[data-sticky-buy]');
    if (stickyCart) stickyCart.addEventListener('click', function () { addToCart(false); });
    if (stickyBuy) stickyBuy.addEventListener('click', function () { addToCart(true); });

    if (sticky && (addBtn || buyBtn)) {
      var anchor = $('.ppp__actions');
      if (anchor && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting); });
        }, { rootMargin: '0px 0px -40px 0px' });
        io.observe(anchor);
      }
    }

    // initial sync
    if (variants) updateForVariant(matchVariant(selectedOptions()));
  }

  function safeJSON(str) { try { return JSON.parse(str); } catch (e) { return null; } }

  function boot() {
    document.querySelectorAll('.ppp[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.ppp[data-section-id]') || (e.target.classList && e.target.classList.contains('ppp') ? e.target : null);
    if (el) { el.dataset.pppInit = ''; initSection(el); }
  });
})();
